import { createReducerFromMap, createAsyncReducer, createDefaultInitialState } from "@coverme/redux";

const initialState = createDefaultInitialState([]);

export const householdsReducer = createReducerFromMap(initialState, {
    ...createAsyncReducer("GET_HOUSEHOLDS", (state, action) => {
        return action.value;
    }),
});
